import { render, staticRenderFns } from "./MarkedForDeleteReports.vue?vue&type=template&id=374294d4&scoped=true"
import script from "./MarkedForDeleteReports.vue?vue&type=script&lang=js"
export * from "./MarkedForDeleteReports.vue?vue&type=script&lang=js"
import style0 from "./MarkedForDeleteReports.vue?vue&type=style&index=0&id=374294d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374294d4",
  null
  
)

export default component.exports